
import Category from '../../Components/Category/Category';
import CategoryCard from '../../Components/CategoryCard/CategoryCard';
import MainCard from '../../Components/MainCard/MainCard';
import FeaturedProduct from '../../Components/FeaturedProduct/FeaturedProduct';
import Header from '../../Components/Header/Header';
import HeaderLower from '../../Components/HeaderLower/HeaderLower';
import Combo from '../../assets/father-banner-desktop.png';
import ComboMobile from '../../assets/father-banner-mobile.gif';

export default function Collection() {
    return (
        <div>
            <Header />
            <HeaderLower />
            <Category title={`Father's Day`} img={Combo} imgMobile={ComboMobile} />
            <CategoryCard title={`Father's Day`} />
            <MainCard category={`COLLECTION`} />
            <FeaturedProduct />
        </div>
    )
}
